import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "sorting_desc",
  "use": "sorting_desc-usage",
  "viewBox": "0 0 8 9",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 8 9\" id=\"sorting_desc\"><path d=\"M7.2 3.8c-.4-.4-1-.4-1.4 0l-.8.8V1c0-.6-.4-1-1-1S3 .4 3 1v3.6l-.8-.8c-.4-.4-1-.4-1.4 0s-.4 1 0 1.4L4 8.4l3.2-3.2c.4-.4.4-1 0-1.4\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol